/**
 * Popover — Radix popover primitive (shadcn API).
 *
 * This used to be a stub that rendered every part as a plain <div>, so the
 * content was always on screen. The API is unchanged (Popover, PopoverTrigger
 * with asChild, PopoverContent with className/align/sideOffset), so existing
 * callers now get a real floating panel, portalled above dialogs.
 */
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '@/lib/utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, style, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'popover-content w-72 rounded-lg border border-v2border bg-surface p-4 text-ink shadow-lg outline-none',
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        className,
      )}
      // Above Radix dialogs (z 9999), so a popover opened inside one is visible.
      style={{ zIndex: 10000, ...style }}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
